/** Unix 秒时间戳 → 本地化日期时间 */
export function formatAddedAt(ts: number): string {
  if (!ts) return "-";
  return new Date(ts * 1000).toLocaleString("zh-CN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

/** evidence 项为完整 URL 或 COS 对象键；cdnBase 为 CDN 根地址 */
export function evidenceToDisplayUrl(key: string, cdnBase: string): string {
  const trimmed = key.trim();
  if (!trimmed) return "";
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  const base = cdnBase.replace(/\/$/, "");
  const path = trimmed.replace(/^\//, "");
  return `${base}/${path}`;
}

export function revokePendingPreviews(
  slots: Array<{ kind: string; preview?: string }>,
): void {
  for (const s of slots) {
    if (s.kind === "pending" && s.preview) URL.revokeObjectURL(s.preview);
  }
}

export function collectEvidenceKeys(
  slots: Array<
    | { kind: "existing"; fileKey: string }
    | { kind: "pending"; status: string; fileKey?: string }
  >,
): string[] {
  const keys: string[] = [];
  for (const s of slots) {
    if (s.kind === "existing") keys.push(s.fileKey);
    else if (s.status === "done" && s.fileKey) keys.push(s.fileKey);
  }
  return keys;
}
